/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import Helmet from 'react-helmet';

// import * as AppPropTypes from '../../lib/PropTypes';

import Plasterify from '../partials/Plasterify';
import styles from '../../../styles/blocks/embed.scss';

const propTypes = {
    embed: PropTypes.object, // eslint-disable-line
    isSection: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    embed: null,
    isSection: false,
    className: null,
};

const Embed = ({ embed, isSection, className }) => {
    const isVideo = embed !== null && (embed.type || 'rich') === 'video';
    const embedWidth = embed !== null ? embed.width || null : null;
    const embedHeight = embed !== null ? embed.height || null : null;
    // prettier-ignore
    const embedRatio = isNumber(embedWidth) && isNumber(embedHeight)
        ? embedHeight / embedWidth
        : null;
    const hasSize = embedRatio !== null || (embedWidth === '100%' && isNumber(embedHeight));
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isSection]: isSection,

                    [styles.isVideo]: isVideo,
                    [className]: className !== null,
                },
            ])}
        >
            {embed !== null && embed.provider === 'instagram' ? (
                <Helmet>
                    <script async src="//www.instagram.com/embed.js" id="instagram" />
                </Helmet>
            ) : null}
            <Plasterify>
                <div className={styles.inner}>
                    {embed !== null ? (
                        <div
                            className={styles.embed}
                            style={{
                                paddingBottom: embedRatio !== null ? `${100 * embedRatio}%` : null,
                                maxWidth: !isVideo && isNumber(embedWidth) ? embedWidth : null,
                                height:
                                    embedRatio === null && embedWidth === '100%'
                                        ? embedHeight
                                        : null,
                            }}
                        >
                            {embed.iframeUrl ? (
                                <iframe
                                    src={embed.iframeUrl}
                                    className={classNames([
                                        styles.iframe,
                                        {
                                            [styles.fullscreen]: hasSize,
                                        },
                                    ])}
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="Embed"
                                />
                            ) : (
                                <div
                                    className={classNames([
                                        styles.iframeContainer,
                                        {
                                            [styles.fullscreen]: hasSize,
                                        },
                                    ])}
                                    dangerouslySetInnerHTML={{ __html: embed.iframe }}
                                />
                            )}
                        </div>
                    ) : null}
                </div>
            </Plasterify>
        </div>
    );
};

Embed.propTypes = propTypes;
Embed.defaultProps = defaultProps;

export default Embed;
